import { getText } from 'i18n/intl';
import { TEDrawerSection, TEInput } from '@timeedit/ui-components';
import type { TReportTemplateProps } from './ReportTemplate';

const GeneralInfo = ({ data, onChange }: TReportTemplateProps) => {
  return (
    <TEDrawerSection label="General info">
      <div className="section-wrapper">
        <div className="section-col">
          <TEInput.PureText
            label="Report Template Type"
            tooltip="Report Template Type"
            value={getText(data.templateType)}
            data-testid="report-template-type"
          />
          <TEInput.Input
            label="Name"
            tooltip="Name"
            value={data.name}
            onChange={(val) => onChange('name', val)}
            placeholder="New Report Template"
            data-testid="report-template-name"
          />
          <TEInput.TextArea
            label="Description"
            tooltip="Description"
            value={data.description}
            onChange={(val) => onChange('description', val)}
            data-testid="padding-desc"
          />
        </div>
      </div>
    </TEDrawerSection>
  );
};

export default GeneralInfo;
